<template>
  <FlexColumn>
    <Label bold text="経験のある職種" />
    <PositionsLabel :positions="this.applicant.currentPositions" />
  </FlexColumn>
</template>

<script>
import FlexColumn from "@/components/atoms/FlexColumn";
import Label from "@/components/atoms/Label";
import PositionsLabel from "@/components/molecules/PositionsLabel";
export default {
  name: "ApplicantPositions",
  components: {PositionsLabel, Label, FlexColumn},
  props: {
    applicant: {
      type: Object
    }
  },
}
</script>

<style scoped>

</style>